import {
  Banner,
  Button,
  Typography,
  useNavigate,
} from '@forgeglobal/design-framework';
import { useStyles } from './styles';

interface BannerBaseProps {
  action?: React.ReactNode;
  severity: 'success' | 'info' | 'warning' | 'error';
  text: string;
}

const BannerBase = ({ action, severity, text }: BannerBaseProps) => {
  return (
    <Banner severity={severity} action={action}>
      <Typography
        variant="body2"
        color="textPrimary"
        data-test-id="login-message">
        {text}
      </Typography>
    </Banner>
  );
};

export const CanNotFindAccountBanner = () => {
  return (
    <BannerBase
      severity="error"
      text="We couldn’t find an account matching the username and password you entered. Please try again."
    />
  );
};

export const AccountIsLockedBanner = () => {
  const nav = useNavigate();
  const classes = useStyles();
  return (
    <BannerBase
      action={
        <Button
          size="small"
          variant="text"
          onClick={() => nav('/reset-password')}
          className={classes.resetButton}
          data-test-id="reset-password-button">
          RESET MY PASSWORD
        </Button>
      }
      severity="error"
      text="Your account is locked due to failed sign in attempts. Your password needs to be reset."
    />
  );
};

export const AccountIsPasswordExpiredBanner = () => {
  const nav = useNavigate();
  const classes = useStyles();
  return (
    <BannerBase
      action={
        <Button
          size="small"
          variant="text"
          onClick={() => nav('/reset-password')}
          className={classes.resetButton}
          data-test-id="reset-password-button">
          RESET MY PASSWORD
        </Button>
      }
      severity="error"
      text="Your password has expired and needs to be reset."
    />
  );
};

export const PasswordChangedBanner = () => {
  return (
    <BannerBase
      severity="success"
      text="Your password has successfully changed."
    />
  );
};
